import cookBookRedirects from '../Cookbook/redirects';
import contentRedirects from '../Content/redirects';
import contactRedirects from '../Contact/redirects';
import knowledgeRedirects from '../Knowledge/redirects';
import measurementsRedirects from '../Measurements/redirects';
import mealPlanRedirects from '../MealPlan/redirects';
import biometricSettingsRedirects from '../BiometricSettings/redirects';
import goalSettingsRedirects from '../GoalSettings/redirects';
import dietSettingsRedirects from '../DietSettings/redirects';
import favMealsRedirects from '../FavMeals/redirects';

const allRedirects = [
  ...cookBookRedirects,
  ...contentRedirects,
  ...contactRedirects,
  ...knowledgeRedirects,
  ...measurementsRedirects,
  ...mealPlanRedirects,
  ...biometricSettingsRedirects,
  ...goalSettingsRedirects,
  ...dietSettingsRedirects,
  ...favMealsRedirects,
];

export default allRedirects;
